import { render, staticRenderFns } from "./WeeklyCoursePlan.vue?vue&type=template&id=ac9424c2"
import script from "./WeeklyCoursePlan.vue?vue&type=script&lang=js"
export * from "./WeeklyCoursePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports